// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement, ReactNode } from 'react';

import './THTag.scss';

interface THTagProps {
    value: ReactNode;
    onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
    color?: string;
    full?: boolean;
    combined?: boolean;
    outline?: boolean;
    textBlack?: boolean;
    borderProps?: string;
    className?: string;
    style?: { [key: string]: string };
}

const THTag = ({
    value,
    onClick,
    color,
    borderProps = '0.25rem solid',
    full = false,
    combined,
    className,
    outline = false,
    textBlack = false,
    style = {},
    ...props
}: THTagProps): ReactElement => (
    <span
        className={classList('th-tag__container', className, {
            'th-tag__clickable': !!onClick,
            'th-tag__combined': combined,
        })}
        onClick={onClick}
        style={{
            border: outline ? `1px solid ${color}` : undefined,
            borderLeft: !full ? color && `${borderProps} ${color}` : outline ? `1px solid ${color}` : undefined,
            backgroundColor: full && !outline ? color : outline ? 'white' : undefined,
            color: full && !outline && !textBlack ? 'white' : outline ? color : textBlack ? 'black' : undefined,
            ...style,
        }}
        {...props}
    >
        <span className="th-tag__text">{value}</span>
    </span>
);

export default THTag;
